// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plus[data-v-7a361103]{height:16px;width:16px;border-radius:50%;background:#0072ff;position:relative}.plus[data-v-7a361103]:after,.plus[data-v-7a361103]:before{content:\"\";position:absolute;display:block;height:1px;width:8px;background:#fff;top:0;left:0;right:0;bottom:0;margin:auto}.plus[data-v-7a361103]:after{transform:rotate(90deg)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
